import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFilePerformanceConfig } from '@v2/pages/batch/details/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const BatchDetailsNCFilePerformanceStack = createStackNavigator();

const BatchDetailsNCFilePerformanceNavigator = () => {
  return (
    <BatchDetailsNCFilePerformanceStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFilePerformanceConfig.map(({ Component, name }) => (
        <BatchDetailsNCFilePerformanceStack.Screen key={name} name={name} component={Component} />
      ))}
    </BatchDetailsNCFilePerformanceStack.Navigator>
  );
};

export { BatchDetailsNCFilePerformanceNavigator };
